/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
// import Debug from 'debug'
/* Nope debugger */
const debuggerFunction = (_pattern, ..._args) => {
    // console.log(_pattern)
};
let debuggerFactory = (_namespace) => debuggerFunction;
/* Try loading 'debug' module */
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const debugModule = require('debug');
    if (debugModule && (typeof debugModule === 'function'))
        debuggerFactory = debugModule;
}
catch (error) {
    //
}
const debugPrefix = 'clsdk';
/* Retrieve the name of the caller 'module' */
/*
const caller = (): string => {

    const err = new Error()

    Error.prepareStackTrace = (_, stack) => stack
    const stack = err.stack as unknown as NodeJS.CallSite[]
    Error.prepareStackTrace = undefined

    const fileName = stack[2].getFileName() || '/'

    return fileName.replace(/^.*[\\/]/, '').replace('.ts', '')

}
*/
/* Return a debugger for the defined namespace */
const debug = (namespace) => {
    return debuggerFactory(`${debugPrefix}:${namespace}`);
};
export default debug;
